import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";
import type { UserAccountValues } from "./types";

// Keep account input outside the active panel without changing Formik's saved baseline.
export const AccountDraft = ({
  draft,
  onChange,
}: {
  draft?: UserAccountValues;
  onChange?: (values: UserAccountValues | undefined) => void;
}) => {
  const { values, dirty, setValues } = useFormikContext<UserAccountValues>();
  const initial = useRef({ restored: false, draft });
  useEffect(() => {
    if (!initial.current.restored) {
      initial.current.restored = true;
      if (initial.current.draft) {
        void setValues(initial.current.draft);
        return;
      }
    }
    onChange?.(dirty ? values : undefined);
  }, [values, dirty, setValues, onChange]);
  return null;
};
